module.exports = __webpack_public_path__ + "static/00001.15107b14.jpg";